import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "iodine-icon-container" }

import { useGrouperStore } from 'stores/GrouperStore';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';
import { useLayoutStore } from 'stores/layout-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperTitle',
  setup(__props) {


const grouperStore = useGrouperStore();
const layoutStore = useLayoutStore();
let mode = layoutStore.layoutMode;
const onClose = () => {
  grouperStore.requestClose();
}

const onExpandCollapse = () => {
  layoutStore.changeMode(mode == GrouperLayoutMode.consolidated ? GrouperLayoutMode.fullScreen : GrouperLayoutMode.consolidated);
};


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_bar = _resolveComponent("q-bar")!

  return (_openBlock(), _createBlock(_component_q_bar, { class: "io-mfe-ig-title-bar" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_icon, {
          name: "fa-solid fa-layer-group",
          class: "iodine-small-icon"
        })
      ]),
      _createVNode(_component_q_toolbar_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Encoder")
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        class: "text-none iodine-icon-button",
        round: "",
        onClick: onExpandCollapse
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_icon, {
            name: "fa-solid fa-compress",
            class: "iodine-small-icon"
          }, null, 512), [
            [_vShow, _unref(mode) === _unref(GrouperLayoutMode).fullScreen]
          ]),
          _withDirectives(_createVNode(_component_q_icon, {
            name: "fa-solid fa-expand",
            class: "iodine-small-icon"
          }, null, 512), [
            [_vShow, _unref(mode) === _unref(GrouperLayoutMode).consolidated]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        class: "text-none iodine-icon-button",
        round: "",
        onClick: onClose
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, {
            name: "fa-solid fa-xmark",
            class: "iodine-small-icon"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})